import { AbstractControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Response, ValidationError } from '../common.types';
import { HttpErrorResponse } from '@angular/common/http';

export const AzcValidators = {
	confirmPassword(passwordField: string, confirmField: string) {
		return (group: FormGroup) => {
			const passwordInput = group.controls[passwordField],
				passwordConfirmationInput = group.controls[confirmField];
			if (passwordInput.value !== passwordConfirmationInput.value) {
				return passwordConfirmationInput.setErrors({ confirm: true });
			} else {
				return passwordConfirmationInput.setErrors(null);
			}
		};
	},

	email(control: AbstractControl): ValidationErrors {
		if (!control.value) {
			return null;
		}
		return Validators.email(control);
	}
};

const StandardErrorResponse  = 'An error occurred, please try again.';

export function handleServerValidation(httpResponse: HttpErrorResponse | any, form?: FormGroup): string {
	try {
		const response = httpResponse.error || httpResponse.json && httpResponse.json() as Response;

		if (form && response.errors) {
			handleValidation(response.errors, form);
		}

		return response.message || StandardErrorResponse;
	} catch (error) {
		console.error(error);
		return StandardErrorResponse;
	}
}

export function handleValidation(errors: ValidationError[], form: FormGroup) {
	for (const error of errors) {
		const control = form.controls[error.fieldName];
		if (control) {
			control.setErrors({ server: error.errorMessage });
		}
	}
}
